import { render, staticRenderFns } from "./priceHead.vue?vue&type=template&id=1ddfe422&scoped=true"
import script from "./priceHead.vue?vue&type=script&lang=js"
export * from "./priceHead.vue?vue&type=script&lang=js"
import style0 from "./priceHead.vue?vue&type=style&index=0&id=1ddfe422&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddfe422",
  null
  
)

export default component.exports